module.exports = "\r\n<div [class.spinner-hidden]=\"!show\" class=\"tmb-spinner\">\r\n  <div class=\"spinner-overlay\">\r\n    <div>\r\n      <mat-spinner [mode]=\"determinate\" strokeWidth=\"5\" width=\"30\" class=\"spinner-icon\"></mat-spinner> \r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/components/spinner/spinner.component.html
// module id = ../../../../../src/app/components/spinner/spinner.component.html
// module chunks = main